import { useLocation, useNavigate, useParams } from "react-router-dom";

/**
 * Custom withRouter HOC for React Router v6
 * This provides backwards compatibility with the withRouter HOC from React Router v5
 *
 * @param {React.ComponentType} Component - The component to wrap
 * @returns {React.ComponentType} The wrapped component with router props
 */
export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        // Create a history-like object from navigate
        const history = {
            push: (path, state) => navigate(path, { state }),
            replace: (path, state) => navigate(path, { replace: true, state }),
            location,
            goBack: () => navigate(-1),
            goForward: () => navigate(1),
            listen: () => () => {},
        };

        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params}
                history={history}
                match={{ params }}
            />
        );
    }

    return ComponentWithRouterProp;
}

export default withRouter;
